export const DEMO_WORKFLOW_ID_1 = '00b787b3-bce7-4d8b-bc43-c4c706ea2d39';
export const DEMO_WORKFLOW_ID_2 = 'a14720ba-2a47-43b0-82b3-91137b92aab7';
